import { useState } from "react";
import { httpStore } from "@/lib/api/instance";
import { StoreConflictException } from "@/lib/api/errors";
import { toastManager } from "@/components/ui/toast";
import { setFlagAckedLocally } from "../lib/flag-message-store";

export function useAckFlag() {
  const [pending, setPending] = useState(false);

  async function ack(
    localId: string,
    remoteId: string,
    opts?: { reply?: string | null; optimistic?: boolean },
  ) {
    const reply = opts?.reply?.trim() ? opts.reply.trim() : null;
    const optimistic = opts?.optimistic ?? true;
    if (optimistic) setFlagAckedLocally(localId, new Date().toISOString(), reply);
    setPending(true);
    try {
      await httpStore.ackFlag(remoteId, reply);
      if (!optimistic) setFlagAckedLocally(localId, new Date().toISOString(), reply);
    } catch (e) {
      const title =
        e instanceof StoreConflictException
          ? "Flag is no longer active"
          : "Couldn't mark resolved";
      toastManager.add({ type: "error", title });
      throw e;
    } finally {
      setPending(false);
    }
  }

  return { ack, pending };
}
